import { render, staticRenderFns } from "./FeedbackEvent.vue?vue&type=template&id=1fc29530&scoped=true&"
import script from "./FeedbackEvent.vue?vue&type=script&lang=js&"
export * from "./FeedbackEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc29530",
  null
  
)

export default component.exports